import React, { FC } from "react"
import { GroupDocument } from "../../../../contexts/devices-context"
import AudioModuleSettings from "./AudioModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type GroupAudioModuleSettingsProps = {
    group: GroupDocument
}

const _GroupAudioModuleSettings: FC<GroupAudioModuleSettingsProps> = ({ group }) => {
    const attrs = useModuleAttributes<"duration" | "samplerate" | "gain" | "armed">(group, "audio")

    return <AudioModuleSettings attrs={attrs} organisation={group.organisation} group={group.id} />
}

export default _GroupAudioModuleSettings
